import "./Connect.module.css";
import Header from "@/reusable_sections/Header";
import DirectSupport from "./sections/DirectSupport";
import MetropolitanPresence from "./sections/MetropolitanPresence";
import Footer from "@/reusable_sections/Footer";
export default function ConnectPage() {
  return <div>
      <Header />
      <DirectSupport />
      <MetropolitanPresence />
      <Footer />
    </div>;
}